import { DocumentProps } from "@/common/types/common";
import { BiometryProps } from "@/entities/biometry/types";

export interface LoanCalculationProps {
  fine: number;
  main: number;
  overdue_days: number;
  reward: number;
  total: number;
}

export interface LoanCostProps {
  fine: number;
  gesv: string;
  hand: number;
  insurance: number;
  main: number;
  overdue_days: number;
  reward: number;
  reward_percentage: string;
  total: number;
}

export interface LoanScheduleProps {
  amount: number;
  paid_amount: number;
  payment_date: string;
  status: number;
  status_label: string;
}

export interface LoanInfoProps {
  amount_hand: number;
  amount_main: number;
  amount_needed: number;
  amount_paid: number;
  calculation: LoanCalculationProps;
  canProlongate: boolean;
  date_given: string;
  date_grace_end: string;
  date_repayment: string;
  director_email: string | null;
  gesv: string;
  insurance: number;
  insurance_signed: boolean;
  loan_id: number;
  overdue_days: number;
  parent_loan_id: number | null;
  prolongation_amount: number;
  prolongation_amount_insurance?: number;
  reward_percentage: string;
  signed_at: string | null;
  stage: number;
  stage_label: string;
  standard: {
    reward: number;
    total: number;
  };
  status: number;
  status_label: string;
  with_insurance: LoanCostProps;
  without_insurance: LoanCostProps;
  discount?: {
    reward: number;
    total: number;
  };
  biometry?: BiometryProps;
  schedule?: LoanScheduleProps[];
  deposit?: { balance?: number };
  canBeDiscounted?: boolean;
  discountedPaymentAmount?: number;
}

export type LoanDocuments = DocumentProps[];

export enum LoanStatus {
  PendingEmail = 0,
  PendingSubmit = 1,
  PendingBiometry = 2,
  BankApplication = 3,
  TransferPending = 4,
  TransferCompleted = 5,
  Adjustments = 6,
  Operational = 7,
  Closed = 8,
  Refinanced = 9,
  Sold = 10,
  RefinancingSigned = 11,
  OnSchedule = 12,
  OnDeferment = 13,
}
